module.exports = __webpack_public_path__ + "static/media/001-ethiopia.ba095149.svg";